import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {Column, useTable} from "react-table";
import * as commonColumnFormatters from '../../_common/column-formatters';
import {formattingPrice} from '../../_common/utils/format';
import CommonGrid from "../../_common/components/CommonGrid";
import useInfiniteScrollControl from "../../_common/components/_custom-hooks/useInfiniteScrollControl";
import {useLawAgentsContext} from "../context/LawAgentsContext";
import * as actions from "../_redux/lawActions";
import {LawAgentsRow} from "../types";

export function TableAgents() {
  const prefix = 'law-column';
  const {formatMessage} = useIntl();
  const [tableRows, setTableRows] = useState<LawAgentsRow[]>([]);
  const columns: Column<LawAgentsRow>[] = useMemo(() => [
    {
      accessor: 'agentId',
      Header: formatMessage({id: `${prefix}-agentID`, defaultMessage: 'Agent ID'})
    },
    {
      accessor: 'agentName',
      Header: formatMessage({id: `${prefix}-agentName`, defaultMessage: 'Name'})
    },
    {
      accessor: 'idNumber',
      Header: formatMessage({id: `${prefix}-idNumber`, defaultMessage: 'ID number'})
    },
    {
      accessor: 'tamalId',
      Header: formatMessage({id: `${prefix}-tamalId`, defaultMessage: 'Tamal ID'})
    },
    {
      accessor: 'email',
      Header: formatMessage({id: `${prefix}-email`, defaultMessage: 'Email'})
    },
    {
      accessor: 'toBePaid',
      Header: formatMessage({id: `${prefix}-toBePaid`, defaultMessage: 'To be paid'})
    },
    {
      accessor: 'paidSoFar',
      Header: formatMessage({id: `${prefix}-paidSoFar`, defaultMessage: 'Paid so far'})
    },
    {
      accessor: 'remainingAmount',
      Header: formatMessage({id: `${prefix}-remainingAmount`, defaultMessage: 'Remaining amount'})
    }
  ], []);
  const data = useMemo(() => [
    ...tableRows
      .map((item) => {

        return {
          agentId: commonColumnFormatters.BoldColumnFormatter(item.agentId),
          agentName: commonColumnFormatters.BoldColumnFormatter(item.agentName),
          idNumber: commonColumnFormatters.BoldColumnFormatter(item.idNumber),
          tamalId: commonColumnFormatters.BoldColumnFormatter(item.tamalId),
          email: commonColumnFormatters.BoldColumnFormatter(item.email),
          toBePaid: commonColumnFormatters.BoldColumnFormatter(formattingPrice(515)),
          paidSoFar: commonColumnFormatters.LawPaidColumnFormatter(formattingPrice(item.paidSoFar), item.paidSoFar),
          remainingAmount: commonColumnFormatters.BoldColumnFormatter(item.paidSoFar
            ? 515 - parseFloat(item.paidSoFar as string) : ''),
        };
      })
  ], [tableRows]);

  const tableInstance = useTable<LawAgentsRow>({columns, data});

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'lawAgents',
    UIContext: useLawAgentsContext(),
    getNewEntities: actions.getLawAgents,
    getNextEntities: actions.getNextLawAgents,
    onEntitiesChange: (entities: LawAgentsRow[]) => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={tableInstance}
      customScrollContainerID={'custom-law-container'}
      customTableStyles={'law-table-agents'}
    />
  );
}